<script>export let value = "";
export let placeholder = "";
export let name = "";
export let error = "";
export let disabled = false;
</script>

<input
	name={name}
	class={['input', $$restProps.class].join(' ')}
	placeholder={placeholder}
	disabled={disabled}
	on:change
	on:input
	on:focusout
	bind:value={value}
	{...$$restProps}
/>
{#if error}
	<span class="text-sm px-2 text-red-500">{error}</span>
{/if}

<style>.input {
  height: 36px;
  padding: 0px 20px;
  align-items: center;
  border-radius: 22px;
  border: 1px solid #dee2e6;
  background: #fff;
  flex-grow: 1;
}</style>
